import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {PolicyProductPersonIntegrationDTO} from '../models/PolicyProductPersonIntegrationDTO';

@Injectable({
  providedIn: 'root'
})
export class PolicyProductPersonIntegrationServiceService {

  private url = environment.baseUrl + '/landing-policy-data';

  constructor(private httpClient: HttpClient) { }

  getFilteredPolicyProductPersonData(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<PolicyProductPersonIntegrationDTO>> {
    return this.httpClient.post<PagedResponseDTO<PolicyProductPersonIntegrationDTO>>(this.url  + '/filter', pagedRequestDTO);
  }

}
